import type { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';

import { COLORS } from '../../IndividualPlan/tokens';

export interface StatCardProps {
  title: string;
  value: ReactNode;
  unit?: string;
  subline?: string;
}

export function StatCard({ title, value, unit, subline }: StatCardProps) {
  return (
    <Box
      data-testid="stat-card"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        gap: 1,
        minHeight: 112,
        p: 2,
        borderRadius: '8px',
        bgcolor: COLORS.bg,
      }}
    >
      <Typography
        component="div"
        data-testid="stat-card-title"
        sx={{
          fontWeight: 700,
          fontSize: 16,
          lineHeight: '24px',
          color: COLORS.muted,
          textTransform: 'capitalize',
        }}
      >
        {title}
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'baseline',
            gap: 0.5,
            color: COLORS.ink,
          }}
        >
          <Typography
            component="span"
            data-testid="stat-card-value"
            sx={{ fontWeight: 600, fontSize: 32, lineHeight: '40px' }}
          >
            {value}
          </Typography>
          {unit ? (
            <Typography
              component="span"
              data-testid="stat-card-unit"
              sx={{ fontWeight: 500, fontSize: 16, lineHeight: '24px' }}
            >
              {unit}
            </Typography>
          ) : null}
        </Box>
        {subline ? (
          <Typography
            component="div"
            data-testid="stat-card-subline"
            sx={{
              fontWeight: 500,
              fontSize: 12,
              lineHeight: '16px',
              color: COLORS.muted,
            }}
          >
            {subline}
          </Typography>
        ) : null}
      </Box>
    </Box>
  );
}
